
import React, { useEffect } from "react";
import { Routes, Route, BrowserRouter, Navigate, useLocation } from "react-router-dom";
import Login from "./pages/common/Login";
import PrivacyPolicy from "./pages/common/PrivacyPolicy";
import SelectProject from "./pages/common/SelectProject";
import SiteSelectProject from "./pages/site/SiteSelectProject";
import AppHome from "./pages/common/AppHome";
import ConSchedule from "./pages/construction/ConSchedule";
import PlanFolder from "./pages/plan/PlanFolder";
import MarSchedule from "./pages/marketing/MarSchedule";
import ConMonitor from "./pages/construction/ConMonitor";
import SiteReport from "./pages/site/SiteReport";
import ConImageList from "./pages/construction/tasks/ConImageList";
import ConNoteList from "./pages/construction/tasks/ConNoteList";
import PlanEditFolder from "./pages/plan/PlanEditFolder";
import PlanUpload from "./pages/plan/PlanUpload"; 
import PlanFilesList from "./pages/plan/PlanFilesList"; 
import MarFolder from "./pages/marketing/MarFolder";
import MarEditFolder from "./pages/marketing/MarEditFolder";
import MarUpload from "./pages/marketing/MarUpload"; 
import MarFilesList from "./pages/marketing/MarFilesList";
import ConFilesFolder from "./pages/construction/ConFilesFolder";
import ConFilesList from "./pages/construction/ConFilesList";
import ConEditFolder from "./pages/construction/ConEditFolder";
import ConUpload from "./pages/construction/ConUpload";
import ConContacts from "./pages/construction/ConContacts";
import FileViewer from "./components/FileViewer";
import { useIdleTimer } from "./hooks/useIdleTimer";
import TradeLogin from "./pages/trade/TradeLogin";
import TradeProjectSelect from "./pages/trade/TradeProjectSelect";
import TradePortal from "./pages/trade/TradePortal";
import TradePdfViewer from "./pages/trade/TradePdfViewer";
import TradeAdminProjects from "./pages/trade/TradeAdminProjects";
import { portalTitle } from "./config/branding";

const isTradeHostname = () => window.location.hostname.toLowerCase().startsWith("trade.");

function TradeProtected({ children }) {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("userRole");
  if (!token || !["trade", "admin", "office", "pm"].includes(role)) {
    return <Navigate to="/trade" replace />;
  }
  return children;
}

function TradeAdminProtected({ children }) {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("userRole");
  if (!token) return <Navigate to="/trade" replace />;
  if (role !== "admin") return <Navigate to="/trade/projects" replace />;
  return children;
}

// 配置 React Router future flags
const router = {
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true,
    v7_prependBasename: true
  }
};

// 内部组件,在 BrowserRouter 内部使用 useIdleTimer
function AppContent() {
  // 调用 useIdleTimer hook (不再需要返回值,因为没有Modal)
  useIdleTimer();
  const location = useLocation();

  useEffect(() => {
    document.title = portalTitle(window.location.hostname, location.pathname);
  }, [location.pathname]);

  return (
    <Routes>
      <Route path="/" element={isTradeHostname() ? <TradeLogin /> : <Login />} />
      <Route path="/trade" element={<TradeLogin />} />
      <Route path="/trade/projects" element={<TradeProtected><TradeProjectSelect /></TradeProtected>} />
      <Route path="/trade/admin/projects" element={<TradeAdminProtected><TradeAdminProjects /></TradeAdminProtected>} />
      <Route path="/trade/project/:projectId" element={<TradeProtected><TradePortal /></TradeProtected>} />
      <Route path="/trade/pdf/:fileId" element={<TradeProtected><TradePdfViewer /></TradeProtected>} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/select_project" element={<SelectProject />} />
      <Route path="/site_select_project" element={<SiteSelectProject />} />
      <Route path="/app_home" element={<AppHome />} />
      <Route path="/construction_page/:projectId" element={<ConSchedule />} />
      <Route path="/planfile_page" element={<PlanFolder />} />
      <Route path="/planfile_page/:parentId" element={<PlanFolder />} />
      <Route path="/planfile_list/:folderId" element={<PlanFilesList />} />
      <Route path="/marketing_page" element={<MarSchedule />} />
      <Route path="/monitor/:projectId" element={<ConMonitor />} /> 
      <Route path="/contacts/:projectId" element={<ConContacts />} />
      <Route path="/site_report" element={<SiteReport />} />
      <Route path="/construction_tasks_images/:taskId" element={<ConImageList />} />
      <Route path="/construction_tasks_notes/:taskId" element={<ConNoteList />} />
      <Route path="/plan_edit_folder" element={<PlanEditFolder />} />
      <Route path="/plan_upload" element={<PlanUpload />} /> 
      <Route path="/marketing_folder" element={<MarFolder />} />
      <Route path="/marketing_upload" element={<MarUpload />} />
      <Route path="/marketing_edit_folder" element={<MarEditFolder />} />
      <Route path="/marketingfile_list/:folder_id" element={<MarFilesList />} />
      <Route path="/construction_files_folder" element={<ConFilesFolder />} />
      <Route path="/construction_edit_folder" element={<ConEditFolder />} />
      <Route path="/construction_upload" element={<ConUpload />} />
      <Route path="/construction_files/:folder_id" element={<ConFilesList />} />
      <Route path="/view_file/:module/:fileId" element={<FileViewer />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter future={router.future}>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
